// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2JnBH","footer":"ModalUpdate_footer__1E_gX"};